<template>
  <v-menu
    v-if="currentId"
    absolute
    class="no_shadow"
    flat
    nudge-left="-12"
    offset-y
  >
    <template v-slot:activator="{ on, attr }">
      <base-button v-bind="attr" class="mr-4" text v-on="on">
        <base-avatar
          class="white--text"
          color="#00897B"
          :data="currentUser"
          size="36"
        ></base-avatar>
        <div class="ml-3 font-weight-regular black--text">
          {{ currentUser | userName }}
        </div>
      </base-button>
    </template>
    <v-card class="dropdown pa-0" flat>
      <v-card-text class="pa-1">
        <div class="d-flex justify-center align-center py-4">
          <base-avatar
            class="white--text"
            color="#00897B"
            :data="currentUser"
            size="64"
          ></base-avatar>
        </div>
        <h3>{{ currentUser | userName }}</h3>
        <!-- <p class="mb-0" style="font-size: 14px; color: #666">{{
          currentUser.username
        }}</p> -->
        <div v-if="primaryRole">
          <v-chip
            class="text-caption ma-1 font-weight-bold"
            label
            small
            :color="primaryRole.meta.color"
            :text-color="primaryRole.meta['text-color']"
            :to="{ name: 'login.select_role' }"
          >
            {{ primaryRole.name }}
          </v-chip>
        </div>
        <v-card-actions class="pt-3">
          <base-button text :to="{ name: 'profile' }">{{
            $t('actions.profile')
          }}</base-button>
          <v-spacer></v-spacer>
          <base-button color="error" text @click="logOut">{{
            $t('actions.logout')
          }}</base-button>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-menu>
  <v-btn
    v-else
    class="text-none"
    color="primary"
    text
    :to="{
      name: 'login',
    }"
  >
    {{ $t('actions.login') }}
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
      primaryRole: 'auth/primaryRole',
    }),
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logOut').then((res) => {
        this.$store.dispatch('auth/gotologOut')
      })
    },
  },
}
</script>

<style scoped></style>
